import React from "react";
import PropTypes from "prop-types";
import { FormControlLabel, IconButton, Tooltip } from "@material-ui/core";
import MaterialTable from "material-table";
import { Col, Row } from "react-bootstrap";
import { GeneralStyle, useStyles } from "./ListOfMyGames.styled";
import TablePagination from "@material-ui/core/TablePagination";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import ModalLoader from "../ModalLoader/ModalLoader";
import { AntSwitch } from "../../helpers/antSwitch";
import { theme as themeConfig } from "../../themes/themes";

const ListOfMyGames = ({
  loadingMyGamesFirst,
  loadingMyGamesAfter,
  loadingMyGamesBefore,
  errorMyGamesFirst,
  errorMyGamesAfter,
  errorMyGamesBefore,
  myspaces,
  toggleChecked,
  pendingRows,
  handleClickActions,
  anchorEl,
  anchorSelected,
  handleCloseActions,
  handleEditSpace,
  setAnchorEl,
  setAnchorSelected,
  setOpenDeleteModal,
  allPages,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const classes = useStyles();

  return (
    <GeneralStyle>
      {((loadingMyGamesFirst && !errorMyGamesFirst) ||
        (loadingMyGamesAfter && !errorMyGamesAfter) ||
        (loadingMyGamesBefore && !errorMyGamesBefore)) && <ModalLoader />}
      {((!loadingMyGamesFirst && errorMyGamesFirst) ||
        (!loadingMyGamesAfter && errorMyGamesAfter) ||
        (!loadingMyGamesBefore && errorMyGamesBefore)) && (
          <Row>
            <Col
              md="12"
              className="d-flex justify-content-center align-content-center my-5"
            >
              <h1 style={{ color: themeConfig.neutral.gray[900] }}>Error :(</h1>
            </Col>
          </Row>
        )}
      {((!loadingMyGamesFirst && !errorMyGamesFirst) ||
        (!loadingMyGamesAfter && !errorMyGamesAfter) ||
        (!loadingMyGamesBefore && !errorMyGamesBefore)) && (
          <MaterialTable
            style={{ boxShadow: "none" }}
            title=""
            columns={[
              {
                title: "Name",
                field: "name",
                type: "string",
                cellStyle: {
                  textAlign: "center",
                  padding: "0px 16px",
                },
              },
              {
                title: "Topic",
                field: "topic",
                type: "string",
                cellStyle: {
                  textAlign: "center",
                  padding: "0px 16px",
                },
              },
              {
                title: "User Assigned",
                field: "userAssigned",
                cellStyle: {
                  textAlign: "center",
                  padding: "0px 16px",
                },
              },
              {
                title: "Created By",
                field: "createUser",
                type: "string",
                cellStyle: {
                  textAlign: "center",
                  padding: "0px 16px",
                },
              },
              {
                title: "Disable",
                field: "edit_record_state",
                type: "string",
                sorting: false,
                cellStyle: {
                  textAlign: "center",
                  padding: "0px 16px",
                },
                render: (rowData) =>
                  rowData && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <FormControlLabel
                        control={
                          <AntSwitch
                            size="small"
                            checked={
                              rowData?.recordState === "Active" ? true : false
                            }
                            disabled={pendingRows?.has(rowData.id)}
                            onChange={() => toggleChecked(rowData)}
                          />
                        }
                      />
                    </div>
                  ),
              },
              {
                title: "Actions",
                title: "Actions",
                field: "internal_action",
                sorting: false,
                cellStyle: {
                  textAlign: "center",
                  padding: "0px 16px",
                },
                render: (rowData) =>
                  rowData && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        zIndex: 0,
                        justifyContent: "center",
                      }}
                    >
                      <Tooltip title="Edit">
                        <IconButton
                          className={classes.delete}
                          onClick={() => handleEditSpace(rowData)}
                        >
                          <EditTwoTone style={{ color: themeConfig.text.primary }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <span>
                          <IconButton
                            disabled={rowData?.recordState === "Active" || pendingRows?.has(rowData.id)}
                            className={classes.delete}
                            style={rowData?.recordState === "Active" || pendingRows?.has(rowData.id) ? { pointerEvents: "none" } : undefined}
                            onClick={() => {
                              setAnchorEl(null);
                              setAnchorSelected(null);
                              setOpenDeleteModal(rowData);
                            }}
                          >
                            <DeleteTwoTone
                              style={{
                                color: themeConfig.text.primary,
                                opacity: rowData.recordState === "Active" ? 0.5 : 1,
                              }}
                            />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </div>
                  ),
              },
            ]
              .map((item) => ({ ...item }))
              .filter((item) => {
                return item.name !== "";
              })}
            data={myspaces}
            options={{
              maxBodyHeight: 550,
              filtering: false,
              search: false,
              paging: false,
              toolbar: false,
              headerStyle: {
                textAlign: "center",
                zIndex: 1,
                fontWeight: "bold",
                width: "calc(13px) !important",
              },
              cellStyle: {
                padding: "5px 10px",
              },
            }}
          ></MaterialTable>
        )}
      {((!loadingMyGamesFirst && !errorMyGamesFirst) ||
        (!loadingMyGamesAfter && !errorMyGamesAfter) ||
        (!loadingMyGamesBefore && !errorMyGamesBefore)) && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              marginTop: "1rem",
            }}
          >
            {allPages > 0 && rowsPerPage && rowsPerPageOptions && (
              <TablePagination
                component="div"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                count={allPages}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={rowsPerPageOptions}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </div>
        )}
    </GeneralStyle>
  );
};

ListOfMyGames.propTypes = {
  pendingRows: PropTypes.instanceOf(Set),
};

export default ListOfMyGames;
